import React from "react";
import SearchBar from "./SearchBar";
import { FaPlus } from "react-icons/fa";
import Pagination from "./pagination";
import Select from "react-select";
import moment from "moment-timezone";
import { FiFilter } from "react-icons/fi";

const Table = ({
  title,
  buttonTitle,
  searchTerm,
  showSearchbar,
  setSearchTerm,
  setSearchData,
  onAddClick,
  columns,
  data,
  actions,
  onPageChange,
  pageCount,
  filterOptions,
  selectedFilter,
  onFilterChange,
  pageLimitOptions,
  selectedPageLimit,
  onPageLimitChange,
  dateFilter,
  toggle,
  setToggle,
  savedStartDate,
  savedEndDate,
  handleClearDates,
  exportButton,
  onExport,
  exportCsv,
  onExportCSV,
}) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      borderColor: "#D1D5DB",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#124699",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#124699" : "white",
      color: state.isSelected ? "white" : "#4B5563",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: state.isSelected ? "#124699" : "#e8effa",
        color: state.isSelected ? "white" : "#4B5563",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#4B5563",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4B5563",
      "&:hover": {
        color: "#124699",
      },
    }),
  };

  return (
    <div className="my-3">
      <section className="shadow-md">
        <div className="bg-white px-4 py-3 flex flex-wrap items-center justify-between rounded-xl gap-3">
          <div>
            <p className="text-xl py-2 font-semibold text-slate-800 uppercase flex">
              {title || "Table Title"}
            </p>
          </div>
          {showSearchbar && (
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              setSearchData={setSearchData}
            />
          )}
          {filterOptions && (
            <div className="flex items-center gap-2 sm:w-72 w-full">
              <p>Filter:</p>
              <Select
                className="w-full"
                value={filterOptions?.find(
                  (option) => option.value === selectedFilter
                )}
                onChange={onFilterChange}
                options={filterOptions}
                styles={customStyles}
                getOptionLabel={(e) => e.label}
                placeholder="Select filter"
              />
            </div>
          )}
             <div className="flex items-center gap-2">
          {buttonTitle && (
            <div className="flex-shrink-0">
              <button
                className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md text-center text-white bg-[#124699] hover:bg-opacity-90"
                onClick={onAddClick}
              >
                <FaPlus className="font-bold text-white w-4 h-4" />
                <p className="font-semibold">{buttonTitle}</p>
              </button>
            </div>
          )}
          {dateFilter && (
            <div className="flex items-end justify-end sm:flex-row flex-col-reverse gap-3">
              {savedStartDate && savedEndDate && (
                <button
                  onClick={handleClearDates}
                  className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md text-center text-white bg-[#124699] hover:bg-opacity-90"
                >
                  <p className="font-semibold">Clear</p>
                </button>
              )}
              <button
                onClick={() => setToggle(true)}
                className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md text-center text-white bg-[#124699] hover:bg-opacity-90"
              >
                <FiFilter className="font-bold text-white w-4 h-4" />
                <p className="font-semibold">Filter</p>
                {savedStartDate && savedEndDate && (
                  <p>
                    (
                    {`${moment(savedStartDate).format("Do MMMM")} - ${moment(
                      savedEndDate
                    ).format("Do MMMM")}`}
                    )
                  </p>
                )}
              </button>
            </div>
          )}
            {exportButton && (
            <button className="bg-[#124699] text-white px-4 py-2 rounded-lg font-semibold" onClick={onExport}>Export PDF</button>
          )}
          </div>
        </div>
        <div className="bg-white overflow-auto px-0">
          <table className="w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className="cursor-pointer border-y border-slate-200 bg-slate-300 p-4 text-center"
                  >
                    {column.label || column.header}
                  </th>
                ))}
                {actions && (
                  <th className="cursor-pointer border-y border-slate-200 bg-slate-300 p-4 text-center">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 ? (
                data?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className="p-4 border-b border-blue-gray-50 text-center"
                      >
                        {column.render
                          ? column.render(row[column.key], row, rowIndex)
                          : row[column.key]}
                      </td>
                    ))}
                    {actions && (
                      <td className="p-4 border-b border-blue-gray-50 text-center">
                        <div className="flex items-center justify-evenly gap-2 font-sans text-md font-medium leading-none text-slate-800">
                          {actions?.map((action, actionIndex) => (
                            <button
                              key={actionIndex}
                              className="h-10 w-10 rounded-lg flex items-center justify-center uppercase text-slate-900 transition-all hover:bg-slate-900/10 active:bg-slate-900/20"
                              onClick={() => action.onClick(row)}
                            >
                              {typeof action?.icon === "function"
                                ? action?.icon(row)
                                : action?.icon}
                            </button>
                          ))}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length + (actions ? 1 : 0)}
                    className="p-4 text-center"
                  >
                    <div className="flex items-center justify-center p-4 w-ful">
                      <div className="text-center animate__animated animate__fadeIn animate__delay-1s">
                        <h2 className="text-3xl font-bold text-gray-900  mb-4">
                          No Data Found
                        </h2>
                        <p className="text-md text-gray-600 mb-6">
                          Unfortunately, we couldn't find any results matching
                          your search.
                        </p>
                        <div className="mt-6">
                          <button
                            className="px-6 py-3 bg-[#124699] text-white text-lg font-semibold rounded-md shadow-lg hover:bg-[#0e377a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#124699] transition-all duration-300 ease-in-out transform hover:scale-105"
                            onClick={() => window.location.reload()}
                          >
                            Try Again
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {pageCount && (
          <>
            <div className="flex justify-between bg-white items-center px-4">
              <div className="flex items-center gap-2">
                <label htmlFor="pageLimit" className="mr-2">
                  Page Limit:
                </label>
                <Select
                  className=""
                  value={pageLimitOptions?.find(
                    (option) => option.value === selectedPageLimit
                  )}
                  onChange={(e) => onPageLimitChange(e.value)}
                  options={pageLimitOptions.map((option) => ({
                    value: option.value,
                    label: option.label,
                  }))}
                  styles={customStyles}
                  menuPlacement="top"
                />
              </div>
              <Pagination pageCount={pageCount} onPageChange={onPageChange} />
            </div>
          </>
        )}
      </section>

    </div>
  );
};

export default Table;
